import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { ImageListItem, Paper } from "@mui/material";

//import { ReactComponent as Logo } from "../../vendor/1spocbeta.svg";
import Csat from "../../components/auth/Csat";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleDomainData } from "../../redux/slices/whitelistsolutionSlice";

// const Brand = styled(Logo)`
//   fill: ${(props) => props.theme.palette.primary.main};
//   width: 250px;
//   height: 64px;
//   margin-bottom: 32px;
// `;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function CustomerSatisfactionScore() {
  const dispatch = useDispatch();
  const domainFetchSingleDataViaDomain = useSelector(
    (state) => state.whitelistsolution.domainFetchSingleDataViaDomain
  );

  const domainName = window.location.hostname;
  // console.log("\n\n Dashboard domainName  == " + domainName);

  React.useEffect(() => {
    dispatch(fetchSingleDomainData(domainName));
  }, [dispatch, domainName]);
  return (
    <React.Fragment>
      {/* <Brand /> */}
      {domainFetchSingleDataViaDomain?.data?.logo_url &&
        domainFetchSingleDataViaDomain?.data?.signIn_logo_url && (
          <ImageListItem>
            <img
              src={
                domainFetchSingleDataViaDomain?.data?.signIn_logo_url ??
                domainFetchSingleDataViaDomain?.data?.logo_url
              }
              alt="logo"
              loading="lazy"
              style={{
                maxWidth: "250px",
                // eslint-disable-next-line no-template-curly-in-string
                marginBottom: "32px",
              }}
            />
          </ImageListItem>
        )}
      <Wrapper>
        <Helmet title="CSAT Rating" />
        <Csat />
      </Wrapper>
    </React.Fragment>
  );
}
export default CustomerSatisfactionScore;
